import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './CircularProgressBar.css'; // Create your own CSS file for styling if needed

const CircularProgressBar = ({ percentage }) => {
  return (
    <div className="circular-progress-container">
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        strokeWidth={10}
        styles={buildStyles({
          textSize: '16px',
          pathColor: `#174ea6`,
          textColor: '#2c3e50',
        })}
      />
    </div>
  );
};

export default CircularProgressBar;
